import { render, staticRenderFns } from "./ManageExpenses.vue?vue&type=template&id=33608d3c&scoped=true&"
import script from "./ManageExpenses.vue?vue&type=script&lang=js&"
export * from "./ManageExpenses.vue?vue&type=script&lang=js&"
import style0 from "./ManageExpenses.vue?vue&type=style&index=0&id=33608d3c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33608d3c",
  null
  
)

export default component.exports